import { Client } from '@/api/getClient';
import { Application } from '@/api/getClientApplication';
import { ClientEmailData } from '@/api/getClientEmail';
import { ClientPhoneData } from '@/api/getClientPhone';
import { ClientApplication } from '@/hooks/webapi/client/useApplicationQuery';
import type { LatestLoan } from '@/hooks/providers/useLatestLoanProvider';
import digestMessage from '@/hooks/context/EventCollector/hash';

export interface IIdentifyEvent {
  type: 'identify';
  timestamp: number;
  client?: Client;
  application?: ClientApplication | Application;
  email?: ClientEmailData;
  phone?: ClientPhoneData;
  client_loan?: LatestLoan | null;
  hasEmail: boolean;
  hasApplication: boolean;
  getHash(): Promise<string>;
}

export default class IdentifyEvent implements IIdentifyEvent {
  readonly type = 'identify' as const;

  readonly timestamp: number;

  readonly client?: Client;

  readonly application?: ClientApplication | Application;

  readonly email?: ClientEmailData;

  readonly phone?: ClientPhoneData;

  readonly client_loan?: LatestLoan | null;

  constructor({
    client,
    application,
    email,
    phone,
    client_loan,
  }: {
    client?: Client;
    application?: ClientApplication | Application;
    email?: ClientEmailData;
    phone?: ClientPhoneData;
    client_loan?: LatestLoan | null;
  }) {
    this.timestamp = new Date().getTime();
    if (client) {
      this.client = client;
    }
    if (application) {
      this.application = application;
    }
    if (email) {
      this.email = email;
    }
    if (phone) {
      this.phone = phone;
    }
    if (client_loan !== undefined) {
      this.client_loan = client_loan;
    }
  }

  get hasEmail() {
    if (this.email?.email) {
      return true;
    }
    return false;
  }

  get hasApplication() {
    return !!this.application;
  }

  async getHash() {
    return digestMessage(this.email?.email ?? '');
  }
}
